import React from 'react';
import { LayoutDashboard, PenLine, Flame } from 'lucide-react';
export function BottomNav() {
  return <div className="fixed bottom-0 left-0 right-0 z-50 p-4 pointer-events-none" data-id="element-29">
      <div className="max-w-md mx-auto bg-app-card/90 backdrop-blur-md border border-app-border rounded-2xl p-2 flex items-center justify-between pointer-events-auto shadow-2xl" data-id="element-30">
        <button className="flex-1 flex flex-col items-center gap-1 p-2 text-app-accent transition-colors" data-id="element-31">
          <LayoutDashboard size={20} data-id="element-32" />
          <span className="text-[10px] font-syne font-bold tracking-wide" data-id="element-33">
            TODAY
          </span>
        </button>

        <button className="flex-1 flex flex-col items-center gap-1 p-2 text-gray-500 hover:text-gray-300 transition-colors" data-id="element-34">
          <PenLine size={20} data-id="element-35" />
          <span className="text-[10px] font-syne font-bold tracking-wide" data-id="element-36">
            CANVAS
          </span>
        </button>

        <button className="flex-1 flex flex-col items-center gap-1 p-2 text-gray-500 hover:text-gray-300 transition-colors relative group" data-id="element-37">
          <div className="relative" data-id="element-38">
            <Flame size={20} className="group-hover:text-app-accent transition-colors" data-id="element-39" />
            <div className="absolute -top-1 -right-2 bg-app-accent text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full" data-id="element-40">
              14
            </div>
          </div>
          <span className="text-[10px] font-syne font-bold tracking-wide group-hover:text-gray-300" data-id="element-41">
            STREAK
          </span>
        </button>
      </div>
    </div>;
}